<template>
	<div>
		<b-container fluid class="margin-top-header">
			<h1 class="p-5 text-center">Crédito Automotriz</h1>
			<v-section-white>
				<b-col cols="12" md="10" offset-md="1" >
					<b-row>
						<b-col cols="12" md="6">
							<b-form-group id="rut" label="Rut">
							<b-form-input v-model.trim="$v.solicitude.rut.$model" :state="$v.solicitude.rut.$dirty ? !$v.solicitude.rut.$error : null" @keyup="formatRut"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Rut Inválido.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group id="name" label="Nombres">
							<b-form-input v-model.trim="$v.solicitude.name.$model" :state="$v.solicitude.name.$dirty ? !$v.solicitude.name.$error : null"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									El nombre debe contener al menos {{$v.solicitude.name.$params.minLength.min}} carácteres.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group id="name" label="Apellido Paterno">
								<b-form-input v-model.trim="$v.solicitude.lastnameFather.$model" :state="$v.solicitude.lastnameFather.$dirty ? !$v.solicitude.lastnameFather.$error : null"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									El apellido paterno debe contener al menos {{$v.solicitude.lastnameFather.$params.minLength.min}} carácteres.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group id="name" label="Apellido Materno">
								<b-form-input v-model.trim="$v.solicitude.lastnameMother.$model" :state="$v.solicitude.lastnameMother.$dirty ? !$v.solicitude.lastnameMother.$error : null"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									El apellido materno debe contener al menos {{$v.solicitude.lastnameMother.$params.minLength.min}} carácteres.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group id="name" label="Renta Liquida">
								<input-currency v-model.trim="$v.solicitude.rent.$model" :state="$v.solicitude.rent.$dirty ? !$v.solicitude.rent.$error : null" @keyup="milesFormaterRen">
									<template>
										<b-form-invalid-feedback id="input-1-live-feedback">
											Renta debe contener al menos {{$v.solicitude.rent.$params.minLength.min}} carácteres y ser numerica.
										</b-form-invalid-feedback>
									</template>
								</input-currency>
							</b-form-group>
						</b-col>
						<b-col cols="12" md="6">
							<b-form-group id="name" label="Monto de crédito">
								<input-currency  v-model.trim="$v.solicitude.amount.$model" :state="$v.solicitude.amount.$dirty ? !$v.solicitude.amount.$error : null">
									<template>
										<b-form-invalid-feedback id="input-1-live-feedback">
											Monto de crédito debe contener al menos {{$v.solicitude.amount.$params.minLength.min}} carácteres y ser numerico.
										</b-form-invalid-feedback>
									</template>
								</input-currency>
							</b-form-group>
							<b-form-group label="Pie" >
								<b-form-select v-model.trim="$v.solicitude.foot.$model" :options="foots" :state="$v.solicitude.foot.$dirty ? !$v.solicitude.foot.$error : null" >
									<template slot="first">
										<option :value="null" disabled>Seleccione Pie</option>
									</template>
								</b-form-select>
								<b-form-invalid-feedback id="input-1-live-feedback" v-if="!$v.solicitude.foot.required">
									Debes ingresar Pie.
								</b-form-invalid-feedback>
								<b-form-invalid-feedback id="input-2-live-feedback">
									Monto del pie debe ser al menos 20% del valor total del vehículo, esto es ${{get20percent()|numberFormat}} <br/>
									<small><b>* Valor esperado de compra del vehículo es equivalente al monto del pie más el monto del crédito solicitado</b></small>
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group label="Celular">
								<b-row>
									<b-col cols="3">
										<b-form-select  v-model.trim="phones.selected" :options="phones.region" ></b-form-select>
									</b-col>
									<b-col>
										<b-form-input v-model="$v.solicitude.phone.$model" :state="$v.solicitude.phone.$dirty ? !$v.solicitude.phone.$error : null"></b-form-input>
										<b-form-invalid-feedback id="input-1-live-feedback">
											El Celular debe contener al menos {{$v.solicitude.phone.$params.minLength.min}} y debe ser numerico.
										</b-form-invalid-feedback>
									</b-col>
								</b-row>
							</b-form-group>
							<b-form-group id="name" label="Email">
								<b-form-input v-model.trim="$v.solicitude.email.$model" :state="$v.solicitude.email.$dirty ? !$v.solicitude.email.$error : null"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Email inválido.
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group label="¿Cómo se enteró del remate?">
								<b-form-select class="mb-3" v-model.trim="$v.solicitude.contact.$model" :state="$v.solicitude.contact.$dirty ? !$v.solicitude.contact.$error : null" >
                                    <optgroup v-for="(group, name) in optionGroups" :label="name" :key="name" >
                                        <option v-for="(option, index) in group" :value="option" v-bind:key="index">{{ option.text }}</option>
                                    </optgroup>
                                </b-form-select>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Debe ingresar como se enteró del remate.
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
						<b-col v-if="loading" cols="12" class="text-center mt-5">
							<grid-loader :color="color"></grid-loader>
						</b-col>
						<b-col cols="12" v-if="this.error.message">
							<b-alert class="text-center" variant="danger" show>{{ error.message }}</b-alert>
						</b-col>
						<b-col cols="12" class="text-center">
							<b-button squared size="lg" class=" mt-5 pl-5 pr-5" variant="outline-macal" @click="send" >¡Solicitar!</b-button>
						</b-col>
					</b-row>
				</b-col>
			</v-section-white>
			<b-row class="mt-5" v-if="simulation.legal">
				<b-col v-if="simulation.legal.length > 0" class="mt-3" cols="10" offset="1" >
					<small>{{simulation.legal[1]}}</small>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
  import SectionWhite from "../../../components/section-white";
  import InputCurrency from "../../../../components/input/input-currency";
  import { required, minLength, numeric, email } from "vuelidate/lib/validators";
  import { isRutValid, isFootValid } from "@/validators";

  export default {
    name: 'financing',
    components: {
		'v-section-white': SectionWhite,
		'input-currency': InputCurrency,
	},
	props: {
		simulation: {
			cae: {default: null},
			total: {default: null},
			amount: {default: null},
			due: {default: null},
			foot: {default: null},
			credit: { type: String },
			legal: { type: Array },
		}
	},
	data (){
		return{
			amount: "",
			due: 60,
            color: "#E4610C",
			solicitude: {
				rut: null,
				name: null,
				lastnameFather: null,
				lastnameMother: null,
				phone: null,
				email: null,
				rent: null,
                amount: null,
                foot: null,
                contact: null
            },
            optionGroups: {
                "Prensa": [],
                "Redes Sociales": [],
                "Portales Web": [],
                "Otros Medios": []
            },
			error: {
				solicitude: {
					rut: [],
					email: []
				},
				message: ""
			},
			phones:{
				region: [
						{value: "+56", text: "+56"}, {value: "+32", text: "+32"}, {value: "+33", text: "+33"}, {value: "+34", text: "+34"}, {value: "+35", text: "+35"}, {value: "+39", text: "+39"},
						{value: "+41", text: "+41"}, {value: "+42", text: "+42"}, {value: "+43", text: "+43"}, {value: "+44", text: "+44"}, {value: "+45", text: "+45"}, {value: "+51", text: "+51"},
						{value: "+52", text: "+52"}, {value: "+53", text: "+53"}, {value: "+55", text: "+55"}, {value: "+57", text: "+57"}, {value: "+58", text: "+58"}, {value: "+61", text: "+61"},
						{value: "+63", text: "+63"}, {value: "+64", text: "+64"}, {value: "+65", text: "+65"}, {value: "+67", text: "+67"}, {value: "+71", text: "+71"}, {value: "+73", text: "+71"},
						{value: "+75", text: "+75"}
				],
				selected: "+56",
			},
            foots:[
                {text: "1.000.000", value: "1000000"},
                {text: "2.000.000", value: "2000000"},
                {text: "3.000.000", value: "3000000"},
                {text: "4.000.000", value: "4000000"},
                {text: "5.000.000", value: "5000000"},
                {text: "6.000.000", value: "6000000"},
                {text: "7.000.000", value: "7000000"},
                {text: "8.000.000", value: "8000000"},
                {text: "9.000.000", value: "9000000"},
                {text: "10.000.000", value: "10000000"},
                {text: "12.000.000", value: "12000000"},
                {text: "14.000.000", value: "14000000"},
                {text: "16.000.000", value: "16000000"},
                {text: "18.000.000", value: "18000000"},
                {text: "20.000.000", value: "20000000"},
                {text: "25.000.000", value: "25000000"},
                {text: "30.000.000", value: "30000000"},
			],
            loading: false,
			state: null,
			invalidFeedback: null,
			validFeedback: null
		}
	},
	validations: {
		solicitude:{
			rut: { required, RutValid: isRutValid },
			name: { required, minLength: minLength(3) },
			lastnameFather: { required, minLength: minLength(3) },
			lastnameMother: { required, minLength: minLength(3) },
			phone: { required, numeric ,minLength: minLength(9) },
			email: { required, email },
			rent: { required ,minLength: minLength(6) },
			amount: { required ,minLength: minLength(6) },
			foot: { required, isFootValid: isFootValid},
			contact: { required }
		}
	},
	created() {
		this.solicitude.foot = String(this.simulation.foot);
		this.getMedia();
		if(this.simulation.credit) {
			this.solicitude.amount = this.simulation.credit.replace(".","");
			this.milesFormater();
		}
		this.send_count()
	},
	methods:{
		send_count(){
			this.axios.post("meters", {id: 212923, url: window.location.href, width: window.innerWidth, height: window.innerHeight}).then(() => {})
		},
		milesFormater(){
			this.solicitude.amount = this.solicitude.amount.toString().replace(/\./g, "").replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
		},
		milesFormaterRen(){
			this.solicitude.rent = this.solicitude.rent.toString().replace(/\./g, "").replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
		},
		get20percent(){
			return parseInt(this.solicitude.amount.replace(/[^\dKk]/g, '')) * 0.2
		},
        getMedia(){
            let self = this
			this.axios.get("financings/types").then(result => {
                result.data.map( media_type => {
                    switch (media_type.id_tipo_medio) {
                        case 1:
                            self.optionGroups["Prensa"].push({text: media_type.nombre_medio, value: media_type.id_medio, father_media_id: media_type.id_tipo_medio, father_text: "Prensa"})
                            break;
                        case 2:
                            self.optionGroups["Redes Sociales"].push({text: media_type.nombre_medio, value: media_type.id_medio, father_media_id: media_type.id_tipo_medio, father_text: "Redes Sociales"})
                            break;
                        case 3:
                            self.optionGroups["Portales Web"].push({text: media_type.nombre_medio, value: media_type.id_medio, father_media_id: media_type.id_tipo_medio, father_text: "Portales Web"})
                            break;
                        case 4:
                            self.optionGroups["Otros Medios"].push({text: media_type.nombre_medio, value: media_type.id_medio, father_media_id: media_type.id_tipo_medio, father_text: "Otros Medios"})
                            break;
                    }
                })
			}).catch(() => {
				this.loading = false
			})
        },
		send(){
			this.$v.solicitude.$touch()
			if(!this.$v.solicitude.$invalid){
				this.loading = true
				let phone = this.solicitude.phone
				this.solicitude.phone = this.phones.selected + this.solicitude.phone
				this.axios.post("financings", this.solicitude).then(result => {
					this.loading = false
					switch(result.data.obj.RespuestaTanner.numero){
						case 1:
							this.$router.push({ name: 'vehicles-financing-rejected', params: {customer: this.solicitude}});
							break;
						case 2:
							this.$router.push({ name: 'vehicles-financing-pending', params: {customer: this.solicitude}});
							break;
						case 3:
							this.$router.push({ name: 'vehicles-financing-success', params: {customer: this.solicitude, simulation: result.data}});
							break;
					}
				}).catch(() => {
					this.loading = false
					this.error.message = "¡Ops, Hubo un error en el proceso!"
				})
				this.solicitude.phone = phone
			}
		},
		formatRut(){
			if(this.solicitude.rut.length > 0){
				this.solicitude.rut = this.solicitude.rut.replace(/[^\dKk]/g, '');
				let dato = this.solicitude.rut;
				let largo = dato.length;
				if (largo === 1) {
					this.dv = dato;
					this.solicitude.rut = '';
					this.digito(this.solicitude.rut, this.dv);
					this.formato()
				} else if (largo > 1) {
					this.dv = dato.substring(largo - 1);
					this.solicitude.rut = dato.substring(largo - 1, 0);
					this.digito(this.solicitude.rut, this.dv);
					this.formato()
				}
			}
		},
		digito(rut,dv) {
			let suma = 0;
			let multiplicador = 2;
			while(rut !== 0){
			if (multiplicador === 8) {
				multiplicador = 2;
			}
			suma += (rut % 10) * multiplicador;
			rut = Math.trunc(rut / 10);
			multiplicador++;
			}
			suma = 11 - (suma % 11);
			switch (suma) {
			case 11:
				this.check = ("0" === dv);
				break;
			case 10:
				this.check = ("K" === dv.toUpperCase());
				break;
			default:
				this.check = (suma.toString() === dv);
				break;
			}
		},
		formato() {
			let rut = (this.solicitude.rut) ? (new Intl.NumberFormat("es-CL").format(parseInt(this.solicitude.rut))) + '-' : '';
			this.solicitude.rut = rut + this.dv;
		},
	},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
